type FrontendRuntimeLogLevel = 'info' | 'warn' | 'error'
type FrontendRuntimeApp = 'admin' | 'shop'

type FrontendRuntimeLogger = Pick<Console, 'info' | 'warn' | 'error'>

type FrontendRuntimeEvent = {
  app: FrontendRuntimeApp
  level: FrontendRuntimeLogLevel
  event: string
  message?: string
  context?: Record<string, unknown>
  correlationId?: string
  error?: unknown
  logger?: FrontendRuntimeLogger
}

const serializeError = (error: unknown): Record<string, unknown> | undefined => {
  if (error === null || error === undefined) return undefined
  if (error instanceof Error) {
    return {
      name: error.name,
      message: error.message,
      stack: error.stack,
    }
  }
  return {
    message: String(error),
  }
}

export const logFrontendRuntimeEvent = ({
  app,
  level,
  event,
  message,
  context,
  correlationId,
  error,
  logger = console,
}: FrontendRuntimeEvent): void => {
  const serializedError = serializeError(error)
  const payload = {
    ts: new Date().toISOString(),
    app,
    level,
    event,
    message,
    correlationId,
    ...(context ? { context } : {}),
    ...(serializedError ? { error: serializedError } : {}),
  }

  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function') {
    window.dispatchEvent(
      new CustomEvent('emporion:frontend-runtime-event', {
        detail: payload,
      }),
    )
  }

  const line = JSON.stringify(payload)
  if (level === 'error') {
    logger.error(line)
    return
  }
  if (level === 'warn') {
    logger.warn(line)
    return
  }
  logger.info(line)
}

export type { FrontendRuntimeApp, FrontendRuntimeEvent, FrontendRuntimeLogLevel }
